import type { FC } from 'react';

import { Seo } from '@/components/seo';

import MeetingsList from './components/MeetingsList';

const MeetingsPage: FC = () => {
  return (
    <>
      <Seo title="Meetings" />
      <MeetingsList />
    </>
  );
};

export default MeetingsPage;
